<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>{{ 'Company settings'| translate }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                  <v-form id="form" ref="form">
                    <v-row>
                        <v-col cols="12" sm="8" md="8">
                            <v-row v-if="errors.length >0">
                                <v-col cols="12" sm="12" md="12">
                                <v-alert
                                    dense
                                    v-for="(v, k) in errors"
                                    :key="k"
                                    outlined
                                    type="error"
                                >{{ k }} {{ v }}</v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        label="Company Color"
                                        name="primarycolor"
                                        autocomplete="off"
                                        :rules="primaryColorRules"
                                        v-model="primarycolor"
                                        hide-details
                                        outlined
                                        required
                                    >
                                        <template v-slot:append>
                                        <v-menu
                                            v-model="menu"
                                            top
                                            nudge-bottom="105"
                                            nudge-left="16"
                                            :close-on-content-click="false"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <div :style="swatchStyle" v-on="on" />
                                            </template>
                                            <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker v-model="primarycolor" flat />
                                            </v-card-text>
                                            </v-card>
                                        </v-menu>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                <v-text-field
                                    outlined
                                    :label="'Session login time' | translate"
                                    v-model="session_log_in_min"
                                    name="session_log_in_min"
                                    :rules="sessionminRules"
                                    autocomplete="off"
                                    type="number"
                                    required
                                ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4"></v-col>
                    </v-row>
                  </v-form>
                    <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    @click="update()"
                    >
                    <v-icon>mdi-content-save</v-icon>
                    </v-btn>


              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
import {
  RESET_STATE,
  FETCH_COMPANY_SETTINGS,
  UPDATE_COMPANY_SETTINGS,
  CHECK_AUTH
} from "@/store/actions.type";
import {  SET_SNACKBAR,SET_LOADING } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
    name:"Settings",
    async beforeRouteUpdate(to, from, next) {
        await store.dispatch(RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile');
        return next();
    },
    async beforeRouteLeave(to, from, next) {
        await store.dispatch(RESET_STATE);
        next();
    },
    computed: {
        ...mapGetters(['companysettings','currentUser']),
        ...mapState({
        errors: state => state.companysettings.companysettingerrors
        }),
    swatchStyle() {
      const { primarycolor, menu } = this;
      return {
        backgroundColor: primarycolor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out"
      };
    }

    },
    created (){
        if(this.currentUser.roles.includes(1) == false){
            this.$router.push("/learningcenter");
        }
    },
    mounted (){
        if(this.companysettings.hasOwnProperty('setting_data')){
         this.primarycolor   =   this.companysettings.setting_data.primary_color
         this.session_log_in_min = this.companysettings.setting_data.session_log_in_min
        }
    },
    data: function() {
        return {
            primarycolor: "#1976D2FF",
            session_log_in_min:'',
            primaryColorRules:[v => !!v || this.$t("Primary color is required")],
            sessionminRules: [v => !!v || this.$t("Session minutes is required")],
            menu: false,
        }
    },
    methods: {
        update(){
            if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_COMPANY_SETTINGS, {
            primary_color: this.primarycolor,
            session_log_in_min: this.session_log_in_min,
          })
          .then(resp => {
            if (resp.hasOwnProperty('success') && resp.success) {
              store.dispatch(CHECK_AUTH).then( resp =>{
                if(resp !== undefined && resp.hasOwnProperty('success') && resp.success == true){
                  store.commit(SET_LOADING, false)
                  store.commit(SET_SNACKBAR, {status: true, message: 'Company settings updated successfully'})
                }
              })
            }
          });
            }
        }
    }
}
</script>